import styled from "styled-components";

export const $SubmitButtonContainer = styled.div`
  margin-top: 25px;
`;
